{
  "profile.title": "What Exognitos knows about me",
  "profile.lede": "Review the durable facts that can shape planning and assistant context. Every item stays traceable, correctable, excludable, and removable.",
  "profile.error.generic": "This profile change could not be completed. Try again.",
  "profile.value.none": "Not recorded",
  "profile.action.export": "Export profile",
  "profile.action.add": "Add fact",
  "profile.action.verify": "Verify",
  "profile.action.dispute": "Mark disputed",
  "profile.action.archive": "Archive",
  "profile.action.restore": "Restore",
  "profile.action.deletePermanently": "Delete permanently",
  "profile.action.cancel": "Cancel",
  "profile.action.save": "Save fact",
  "profile.filter.category": "Category",
  "profile.filter.allCategories": "All categories",
  "profile.filter.includeSensitive": "Show sensitive facts",
  "profile.filter.includeSensitiveDescription": "Sensitive values stay hidden until you explicitly reveal them.",
  "profile.filter.includeArchived": "Show archived facts",
  "profile.filter.includeArchivedDescription": "Archived facts are excluded from future context.",
  "profile.stale.title": "Needs review",
  "profile.stale.description": "Facts whose review date has passed or whose verification needs attention.",
  "profile.stale.empty": "Nothing needs review right now.",
  "profile.stale.badge": "Review due",
  "profile.facts.title": "Profile facts",
  "profile.facts.description": "Account timezone, locale, and display name remain canonical account settings; this list stores supporting personal context.",
  "profile.empty.title": "No profile facts yet",
  "profile.empty.description": "Add only the context you want Exognitos and authorized assistants to use.",
  "profile.meta": "{{source}} · updated {{updated}} · revision {{revision}}",
  "profile.delete.title": "Permanently delete “{{title}}”?",
  "profile.delete.description": "This removes the fact and its continuity from assistant context. Independent tasks, notes, and other records are not deleted.",
  "profile.form.createTitle": "Add a profile fact",
  "profile.form.editTitle": "Edit profile fact",
  "profile.form.description": "Keep one durable claim per fact so it can be reviewed and withdrawn precisely.",
  "profile.form.category": "Category",
  "profile.form.key": "Stable key",
  "profile.form.keyHint": "Lowercase letters, numbers, dots, hyphens, or underscores; for example communication.response_style.",
  "profile.form.title": "Plain-language title",
  "profile.form.value": "Value",
  "profile.form.sensitivity": "Sensitivity",
  "profile.form.assistantConsent": "Allow in authorized assistant context",
  "profile.form.assistantConsentDescription": "The assistant still needs the matching field scope; withdrawing consent excludes this value from new context packets.",
  "profile.form.consentPurpose": "Why may the assistant use this?",
  "profile.form.required": "Provide a key, title, and value.",
  "profile.form.consentPurposeRequired": "Explain the purpose before granting assistant access.",
  "profile.form.loadingFact": "The latest revision is still loading. Try saving again in a moment.",
  "profile.history.title": "Revision history",
  "profile.history.empty": "No earlier revision has been recorded.",
  "profile.history.item": "{{action}} · revision {{revision}} · {{date}}",
  "profile.category.communication": "Communication",
  "profile.category.values_goals": "Values and goals",
  "profile.category.constraints": "Constraints and availability",
  "profile.category.people_roles": "People and roles",
  "profile.category.environment": "Environment and tools",
  "profile.category.accessibility": "Accessibility",
  "profile.category.wellbeing": "Wellbeing",
  "profile.category.health": "Health",
  "profile.category.financial": "Financial",
  "profile.sensitivity.normal": "Ordinary",
  "profile.sensitivity.private": "Private",
  "profile.sensitivity.sensitive": "Sensitive",
  "profile.verification.unverified": "Unverified",
  "profile.verification.verified": "Verified",
  "profile.verification.disputed": "Disputed",
  "profile.source.user_authored": "Added by you",
  "profile.source.assistant_proposed": "Proposed by an assistant",
  "profile.source.imported": "Imported",
  "profile.source.system_reference": "Account reference"
}
